import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { isNativeApp } from "../../../lib/platform/native";

/**
 * Roteia o TOQUE numa push notification dentro do app nativo.
 *
 * Na web quem faz isso é o `firebase-messaging-sw.js`: ele lê `data.url` do
 * payload e abre/foca a aba naquele caminho. No app das lojas não há service
 * worker (o `build:mobile` o remove do bundle de propósito) — o toque chega
 * pelo listener `notificationActionPerformed` do plugin, e sem este
 * componente TODO toque cairia na tela em que o app estava. É a classe do
 * BUG-152: push que promete um destino ("volte pra registrar as páginas") e
 * entrega outro.
 *
 * Decisões:
 *  - Só aceita CAMINHO relativo ("/book/x"). `data.url` é escrito pelo nosso
 *    servidor (`sendPushToUser` faz `payload.url ?? "/home"`), mas payload é
 *    dado, não código — uma URL absoluta ou um esquema estranho não vira
 *    navegação.
 *  - Monta uma vez no App (dentro do Router, ao lado do FcmTokenSync) e na
 *    web é no-op puro: nenhum listener, nenhum import de plugin.
 *  - O toque que ABRE o app frio também chega por aqui: o bridge do
 *    Capacitor retém o evento até o primeiro listener registrar. Se num
 *    aparelho específico o evento se perder, o custo é cair na Home — nunca
 *    uma tela quebrada.
 */
export function NativePushTapNavigator() {
  const navigate = useNavigate();

  useEffect(() => {
    if (!isNativeApp()) return;
    let cancelled = false;
    let unsubscribe: () => void = () => undefined;
    (async () => {
      const { onNotificationTap } = await import("../../../lib/firebase/messaging");
      const off = await onNotificationTap((payload) => {
        const url = payload.url;
        if (!url || !url.startsWith("/") || url.startsWith("//")) return;
        navigate(url);
      });
      if (cancelled) {
        off();
        return;
      }
      unsubscribe = off;
    })();
    return () => {
      cancelled = true;
      unsubscribe();
    };
  }, [navigate]);

  return null;
}
